import CrudForm from "../../../components/ui/crud form/CrudForm";
import SearchBar from "../../../components/ui/crud searchbar/Searchbar";
import CrudTable from "../../../components/ui/crud table/CrudTable";
import ConfirmModal from "../../../components/ui/confirm modal/ConfirmModal";
import { useManageServices } from "./hooks/useManageServices";

function ManageServices() {
  const {
    tk,
    search,
    setSearch,
    deleteModal,
    editingItem,
    newFormKey,
    submitError,
    isEditLoading,
    formDefaults,
    fields,
    columns,
    filtered,
    isLoading,
    errorMessage,
    pending,
    handleSubmit,
    confirmDelete,
    handleEdit,
    handleDeleteClick,
    cancelEdit,
  } = useManageServices();

  return (
    <div className="col">
      <h2 className="mb-4">{tk("heading")}</h2>

      {errorMessage && (
        <div className="alert alert-danger" role="alert">
          {typeof errorMessage === "string"
            ? errorMessage
            : JSON.stringify(errorMessage)}
        </div>
      )}

      {submitError && (
        <div className="alert alert-warning" role="alert">
          <strong>{tk("alerts.couldNotSave")}</strong>
          <pre
            className="mb-0 mt-2 small"
            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {submitError}
          </pre>
        </div>
      )}

      {editingItem && (
        <p className="small text-muted mb-3">{tk("messages.leaveImage")}</p>
      )}

      {editingItem && isEditLoading && (
        <p className="small text-muted mb-2">{tk("messages.loadingEdit")}</p>
      )}

      <CrudForm
        key={editingItem ? `edit-${editingItem.id}` : `new-${newFormKey}`}
        fields={fields}
        defaultValues={formDefaults}
        onSubmit={handleSubmit}
        submitText={
          editingItem ? tk("buttons.update") : tk("buttons.create")
        }
        onCancel={editingItem ? cancelEdit : undefined}
      />

      <SearchBar
        value={search}
        onChange={setSearch}
        placeholder={tk("searchPlaceholder")}
      />

      {isLoading ? (
        <p className="text-muted">{tk("messages.loadingList")}</p>
      ) : (
        <CrudTable
          columns={columns}
          data={filtered}
          onEdit={handleEdit}
          onDelete={handleDeleteClick}
          actionsLabel={tk("table.actions")}
          editLabel={tk("table.edit")}
          deleteLabel={tk("table.delete")}
        />
      )}

      <ConfirmModal
        show={deleteModal.show}
        onClose={deleteModal.close}
        onConfirm={confirmDelete}
        title={tk("modal.title")}
        message={tk("modal.message")}
        cancelLabel={tk("modal.cancel")}
        confirmLabel={tk("modal.delete")}
      />

      {pending && (
        <p className="small text-muted mt-2">{tk("messages.saving")}</p>
      )}
    </div>
  );
}

export default ManageServices;
